<script setup>
import { ref } from "vue"
import { useErrorsStore } from '@/Stores/errors'
const errors = useErrorsStore()

const props = defineProps({
	user: {
		type: Object,
		required: true
	},
})

const emit = defineEmits([
	'user-deleted',
])

const button = ref(null) // template ref

function deleteUser() {
	errors.confirm({
		title: "Delete User",
		message: "Are you sure you want to delete this user?",
		type: "danger",
		btnText: "Delete User",
		onConfirm: () => {
			doDeleteUser()
		}
	})
}

function doDeleteUser(){
	button.value.waitFor(
		axios.delete('/users/' + props.user.id)
		.then((response) => {
			if( response.data.status == 'success' ) {
				emit('user-deleted')
				errors.push({
					title: 'Success',
					message: 'User deleted',
					type: 'success'
				})
			}
		})
	)
}
</script>

<template>
	<PromiseButton
		ref="button"
		color="red"
		type="button"
		@click="deleteUser"
		data-testid="delete-user-button"
	>
		<slot>Delete this user</slot>
	</PromiseButton>
</template>